<app-smash-back-btn (goBack)="back()"></app-smash-back-btn>

<div class="premium-card">
    <div class="premium-card-header">
        <h1>
            {{ 'PREMIUM_TEAM_GROUP_DETAILS_TITLE_SECTION' | translate }}
        </h1>
    </div>
    <div class="premium-card-center container-form">
        <form class="premium-card-center-form" [formGroup]="groupDetailsForm" [appConnectForm]="groupDetails$ | async" (ngSubmit)="onSubmit()">
            <app-smash-input type="text" borderStyle="full" placeholder="{{'PREMIUM_TEAM_GROUP_DETAILS_NAME_PLACEHOLDER' | translate }}"
                formControlName="name" [error]="groupDetailsFormSubmitted && f.name.errors"
                [disabled]="((groupDetails$ | async) && (groupDetails$ | async)?.provisioned)">
            </app-smash-input>
        </form>
    </div>
    <div class="premium-card-footer">
        <div class="confirmation-message-container confirmation-message" *ngIf="groupUpdated" translate>PREMIUM_DOMAIN_SETTINGS_SAVED
        </div>
        <button class="btn-new white group-buttons"
            [disabled]="!groupDetailsForm.dirty || (groupUpdating$ | async) || (groupDetails$ | async)?.provisioned">{{
            'PREMIUM_TEAM_GROUP_DETAILS_BUTTON_LABEL_CANCEL' |
            translate }}</button>
        <button type="submit" class="btn-new red group-buttons" (click)="onSubmit()"
            [disabled]="!groupDetailsForm.dirty || (groupUpdating$ | async) || (groupDetails$ | async)?.provisioned">{{
            'PREMIUM_TEAM_GROUP_DETAILS_BUTTON_LABEL_SAVE' |
            translate }}</button>
    </div>
</div>

<div class="premium-card">
    <div class="premium-card-header">
        <div class="premium-card-header-title">
            <h1 translate>PREMIUM_TEAM_GROUP_DETAILS_ROLES_TITLE_SECTION</h1>
            <h2 translate [translateParams]="{'group': (groupDetails$ | async)?.name}">PREMIUM_TEAM_GROUP_DETAILS_ROLES_DESCRIPTION</h2>
        </div>
        <div class="premium-card-header-actions">
            <div class="icon icon-refresh" (click)="refreshRoles()">
                <i class="icon-smash_remote"></i>
            </div>
            <!-- FIX ME RE-ENABLE ME WHEN PAGINATION AND/OR DYNAMIC USER SEARCH IS IMPLEMENTED -->
            <button class="btn-new red" *ngIf="!(groupDetails$ | async)?.provisioned" (click)="openModalAttachRoleToGroup()">
                {{ 'PREMIUM_TEAM_GROUP_DETAILS_BUTTON_LABEL_ATTACH_ROLE_TO_GROUP' | translate }}
            </button>
        </div>
    </div>
    <ng-container *ngIf="(groupRolesLoading$ | async); else groupRolesNotLoading">
        <div class="premium-card-loading-container">
            <div class="loading-spinner-grey"></div>
        </div>
    </ng-container>
    <ng-template #groupRolesNotLoading>
        <div class="premium-card-center">
            <ng-container *ngIf="(groupRolesLoaded$ | async); else groupRolesNotLoaded">
                <ng-container *ngIf="(groupRoles$ | async)?.length > 0; else noRoles">
                    <app-smash-data-table [data]="(groupRoles$ | async)" [searchValue]="search"
                        [columns]='roleListColumnsEnabled' [enableMoreOptions]='!(groupDetails$ | async)?.provisioned'
                        [enableColumnOptions]='false' rowClickable='false' [paginationEnabled]="true">
                        <ng-template #optionsList let-item>
                            <li (click)="openModalDetachRoleFromGroup(item)">
                                <a>
                                    {{ 'PREMIUM_TEAM_GROUP_DETAILS_BUTTON_LABEL_REMOVE_ROLE_FROM_GROUP' | translate }}
                                </a>
                            </li>
                        </ng-template>
                    </app-smash-data-table>
                </ng-container>
                <ng-template #noRoles>
                    <div class="premium-card-center-no-content">
                        <div class="premium-card-center-no-content-message">
                            {{ 'PREMIUM_TEAM_GROUPS_DETAILS_ROLES_TABLE_NO_ROLES' | translate }}
                        </div>
                    </div>
                </ng-template>
            </ng-container>
            <ng-template #groupRolesNotLoaded>
                <!-- TO DO Error Message -->
            </ng-template>
        </div>
    </ng-template>
</div>

<div class="premium-card">
    <div class="premium-card-header">
        <div class="premium-card-header-title">
            <h1 translate>PREMIUM_TEAM_GROUP_DETAILS_MEMBERS_TITLE_SECTION</h1>
            <h2 translate [translateParams]="{'group': (groupDetails$ | async)?.name}">PREMIUM_TEAM_GROUP_DETAILS_MEMBERS_DESCRIPTION</h2>
        </div>
        <div class="premium-card-header-actions">
            <div class="icon icon-refresh" (click)="refreshMembers()">
                <i class="icon-smash_remote"></i>
            </div>
            <!-- FIX ME RE-ENABLE ME WHEN PAGINATION AND/OR DYNAMIC USER SEARCH IS IMPLEMENTED -->
            <button class="btn-new red" *ngIf="!(groupDetails$ | async)?.provisioned" (click)="openModalAttachUserToGroup()">
                {{ 'PREMIUM_TEAM_GROUP_DETAILS_BUTTON_LABEL_ATTACH_MEMBER_TO_GROUP' | translate }}
            </button>
        </div>
    </div>
    <ng-container *ngIf="(groupMembersLoading$ | async); else groupMembersNotLoading">
        <div class="premium-card-loading-container">
            <div class="loading-spinner-grey"></div>
        </div>
    </ng-container>
    <ng-template #groupMembersNotLoading>
        <div class="premium-card-center">
            <ng-container *ngIf="(groupMembersLoaded$ | async); else groupMembersNotLoaded">
                <ng-container *ngIf="(groupMembers$ | async)?.length > 0; else noMembers">
                    <app-smash-data-table [data]="(groupMembers$ | async)" [searchValue]="search"
                        [columns]='membersListColumnsEnabled' [enableMoreOptions]='!(groupDetails$ | async)?.provisioned'
                        [enableColumnOptions]='false' rowClickable='true' (rowClicked)="goToMemberDetails($event.id)" [paginationEnabled]="true">
                        <ng-template #optionsList let-item>
                            <li (click)="openModalDetachUserFromGroup(item)">
                                <a>
                                    {{ 'PREMIUM_TEAM_GROUP_DETAILS_BUTTON_LABEL_REMOVE_MEMBER_FROM_GROUP' | translate }}
                                </a>
                            </li>
                        </ng-template>
                    </app-smash-data-table>
                </ng-container>
                <ng-template #noMembers>
                    <div class="premium-card-center-no-content">
                        <div class="premium-card-center-no-content-message">
                            {{ 'PREMIUM_TEAM_GROUPS_DETAILS_MEMBERS_TABLE_NO_MEMBERS' | translate }}
                        </div>
                    </div>
                </ng-template>
            </ng-container>
            <ng-template #groupMembersNotLoaded>
                <!-- TO DO Error Message -->
            </ng-template>
        </div>
    </ng-template>
</div>